import React, {
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { Provider } from 'react-redux';
import { RootNavigator } from './navigation';
import { persistor, store } from './services/redux';
import { PersistGate } from 'redux-persist/integration/react';
import NotificationProvider from './services/notification/NotificationProvider';

const HeightContext = React.createContext<{
  height?: number;
  setHeight: Dispatch<SetStateAction<number | undefined>>;
}>({
  height: undefined,
  setHeight: () => {},
});

export const useAppHeight = () => useContext(HeightContext);

const Height: FC<PropsWithChildren> = ({ children }) => {
  const [height, setHeight] = useState<number>();
  return (
    <HeightContext.Provider value={{ height, setHeight }}>
      {children}
    </HeightContext.Provider>
  );
};

const App: FC = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SafeAreaProvider>
          {/* Disable on website */}
          {/* <NotificationProvider> */}
          <Height>
            <RootNavigator />
          </Height>
          {/* </NotificationProvider> */}
        </SafeAreaProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
